// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__11H20","colCheckbox":"styles_colCheckbox__dte6g"};